import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem } from "@mui/material";
import "../../ViewInfo.css";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";
import { Student_Search_School } from "../../../api/Student_Search_School";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";

function ViewBasicInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formBasicInfo, setformBasicInfo] = useState({
    Created_At: "",
    First_Name: "",
    Last_Name: "",
    Gender: "",
    Number: "",
    Nationality: "",
    DOB: "",
    uncleanSchool: "",
    School_id: "",
    ProgrammeTitle: "",
    ProgrammeDate: "",
    ProgrammeVarient: "",
  });

  const [SEFProgress, setSEFProgress] = useState({
    BasicInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      //id,
      localStorage.getItem("Student_id"),
      "BasicInfo",
      setformBasicInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      //id,
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformBasicInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNumberChange = (value) => {
    setformBasicInfo((prevData) => ({
      ...prevData,
      Number: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      { BasicInfo: formBasicInfo, "SEFProgress.BasicInfo": "In_Progress" },
      "Registers_2025",
      "All",
      setStatus,
      //id,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        BasicInfo: formBasicInfo,
        //SEFProgress: { BasicInfo: "Complete" },
        "SEFProgress.BasicInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      BasicInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const requiredFields = [
    "First_Name",
    "Last_Name",
    "Gender",
    "Number",
    "Nationality",
    "DOB",
  ];

  const isFormComplete = requiredFields.every(
    (field) =>
      formBasicInfo &&
      formBasicInfo[field] &&
      formBasicInfo[field] !== "" &&
      ((formBasicInfo.uncleanSchool &&
        formBasicInfo.uncleanSchool.includes("NEW SCHOOL: ")) ||
        formBasicInfo.School_id)
  );

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  console.log(localStorage);

  //--------------------School Search--------------------

  const [Schools, setSchools] = useState([]);
  const [uncleanCountry, setuncleanCountry] = useState("");
  const [uncleanPostCode, setuncleanPostCode] = useState("");
  const [CorrectSchool, setCorrectSchool] = useState({});

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (formBasicInfo.uncleanSchool) {
        Student_Search_School(
          "Schools",
          "All_Schools",
          localStorage.getItem("Student_id"),
          formBasicInfo.uncleanSchool,
          uncleanCountry,
          uncleanPostCode,
          setSchools,
          logoutStudent
        );
      }
    }, 500); // Adjust the delay as needed (500ms in this case)

    return () => clearTimeout(delayDebounceFn);
  }, [formBasicInfo.uncleanSchool, uncleanCountry, uncleanPostCode]);

  useEffect(() => {
    if (formBasicInfo.School_id && formBasicInfo.School_id.length > 0) {
      Get_One_From_MongoDB(
        "Schools",
        "All_Schools",
        formBasicInfo.School_id,
        setCorrectSchool,
        logoutStudent
      );
    }
  }, [formBasicInfo.School_id]);

  console.log("setCorrectSchool");
  console.log(CorrectSchool);

  return (
    <div className="view-basic-info-container">
      <h1>Attendee Information</h1>
      {SEFProgress &&
      SEFProgress.BasicInfo &&
      (SEFProgress.BasicInfo === "Complete" ||
        SEFProgress.BasicInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}
      <form className="view-basic-info-form">
        <TextField
          label="First Name"
          variant="outlined"
          fullWidth
          required
          name="First_Name"
          value={formBasicInfo?.First_Name}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label="Last Name"
          variant="outlined"
          fullWidth
          required
          name="Last_Name"
          value={formBasicInfo?.Last_Name}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <TextField
          label="Gender"
          variant="outlined"
          fullWidth
          required
          name="Gender"
          value={formBasicInfo?.Gender}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem key={""} value={""}></MenuItem>
          <MenuItem key={"M"} value={"M"}>
            M
          </MenuItem>
          <MenuItem key={"F"} value={"F"}>
            F
          </MenuItem>
        </TextField>
        <TextField
          label="Nationality"
          variant="outlined"
          fullWidth
          required
          name="Nationality"
          value={formBasicInfo?.Nationality}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
        />
        <PhoneInput
          // flagUrl="http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
          className="Phone"
          placeholder="Enter phone number"
          label="Phone Number"
          variant="outlined"
          fullWidth
          required
          name="Number"
          value={formBasicInfo?.Number}
          onChange={handleNumberChange}
        />
        <TextField
          variant="outlined"
          label="Full Phone Number:"
          fullWidth
          required
          type="tel"
          name="Number"
          value={formBasicInfo?.Number}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          disabled={true}
        />
        <TextField
          label="Date of Birth"
          variant="outlined"
          fullWidth
          required
          name="DOB"
          type="date"
          value={formBasicInfo?.DOB}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />
        {formBasicInfo.uncleanSchool &&
        formBasicInfo.uncleanSchool.includes("NEW SCHOOL: ") ? (
          <>
            Your school of attendance has been recorded as{" "}
            {formBasicInfo.uncleanSchool}.<br></br>
          </>
        ) : formBasicInfo.School_id && formBasicInfo.School_id.length > 0 ? (
          <>
            Your school of attendance has been recorded as{" "}
            {CorrectSchool.School_Name}.<br></br>
          </>
        ) : (
          <>
            <br></br>
            We work closely with schools, so please help us correctly identify
            which school you are attending by searching for your school in the
            below table using the "Name" and "Country" fields. Once you have
            found your school, click "Select" to confirm your choice.
            <br></br>
            <br></br>
            Unable to find your school? It could be due to spelling differences,
            try shortening the Name field, i.e. "James" instead of "St.
            James's".
            <br></br>
            <br></br>
            Certain your school is not in our system? Please complete all 3
            fields and use the "School Cannot Be Found, New School" button at
            the bottom.
            <br></br>
            <TextField
              label="Search School Name"
              variant="outlined"
              fullWidth
              required
              name="uncleanSchool"
              value={formBasicInfo?.uncleanSchool}
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
                shrink: true,
              }}
            />
            <TextField
              label="Search School Country"
              variant="outlined"
              fullWidth
              required
              name="uncleanCountry"
              value={uncleanCountry}
              onChange={(e) => setuncleanCountry(e.target.value)}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
                shrink: true,
              }}
            />
            <TextField
              label="Search School PostCode"
              variant="outlined"
              fullWidth
              required
              name="uncleanPostCode"
              value={uncleanPostCode}
              onChange={(e) => setuncleanPostCode(e.target.value)}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
                shrink: true,
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                setformBasicInfo((prevData) => ({
                  ...prevData,
                  uncleanSchool:
                    "NEW SCHOOL: " +
                    formBasicInfo.uncleanSchool +
                    ", " +
                    uncleanCountry +
                    ", " +
                    uncleanPostCode,
                }))
              }
            >
              School Cannot Be Found, New School
            </Button>
            {Schools.length > 0 && (
              <table
                className="schools-table"
                style={{ backgroundColor: "white", padding: "10px" }}
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Country</th>
                    <th>Postcode</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Schools.map((school) => (
                    <tr key={school.ID}>
                      <td>{school.School_Name}</td>
                      <td>{school.School_Country}</td>
                      <td>{school.School_PostCode}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            setformBasicInfo((prevData) => ({
                              ...prevData,
                              School_id: school._id,
                            }))
                          }
                        >
                          Select
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        <WEFChangePage Page={"BasicInfo"} PageButtonStatus={PageButtonStatus} />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.BasicInfo &&
                (SEFProgress.BasicInfo === "Complete" ||
                  SEFProgress.BasicInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.BasicInfo &&
                (SEFProgress.BasicInfo === "Complete" ||
                  SEFProgress.BasicInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewBasicInfo;
